<template>
  <div class="marquee-message"
        ref="marqueeMessage">
    <div ref="marqueeMessageMeasure"
        class="--hidden">{{message}}</div>
    <span class="marquee-message_text"
          :class="{'marquee': isMarquee}">
      <p>{{message}}</p>
    </span>
  </div>
</template>
<script>
export default {
  name: 'MarqueeMessage',
  props: {
    message: {
      type: String,
      default: ''
    },
    speed: {
      type: Number,
      default: 20
    },
    parent: {
      // 親コンポーネントを確認するため
      type: String,
      default: ''
    }
  },
  data () {
    return {
      parentWidth: 0,
      childWidth: 0,
      isMarquee: false
    }
  },
  mounted () {
    this.parentWidth = this.$refs.marqueeMessage.clientWidth
    this.setParam()
    const that = this
    window.addEventListener('resize', function () {
      that.setParam()
    })
  },
  watch: {
    message () {
      this.setParam()
    }
  },
  methods: {
    setParam () {
      const that = this
      setTimeout(function () {
        that.getChildWidth()
        that.checkMarquee()
      }, 1000)
    },
    getChildWidth () {
      this.parentWidth = this.$refs.marqueeMessage.clientWidth
      this.childWidth = this.$refs.marqueeMessageMeasure.clientWidth
    },
    checkMarquee () {
      if (this.parentWidth === 0 || this.childWidth === 0) {
        this.isMarquee = false
      } else {
        this.isMarquee = this.parentWidth <= this.childWidth
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .marquee-message {
    width: 100%;
    position: relative;
  }
  .marquee-message_text {
    width: fit-content;
  }
  /deep/ .marquee-text-text {
    width: 100%;
  }
  .--hidden {
    visibility: hidden;
    position: fixed;
  }
  .marquee {
    width: 100%;
    padding:0.5em 0;
    overflow:hidden;
    margin-bottom:10px;
    position:relative;
  }

  .marquee p:after {
    content:"";
    white-space:nowrap;
    padding-right:50px;
  }

  .marquee p {
    margin:0;
    padding-left: 200px;
    display:inline-block;
    white-space:nowrap;
    -webkit-animation-name:marquee;
    -webkit-animation-timing-function:linear;
    -webkit-animation-duration:10s;
    -webkit-animation-iteration-count:infinite;
    -moz-animation-name:marquee;
    -moz-animation-timing-function:linear;
    -moz-animation-duration:10s;
    -moz-animation-iteration-count:infinite;
    -ms-animation-name:marquee;
    -ms-animation-timing-function:linear;
    -ms-animation-duration:10s;
    -ms-animation-iteration-count:infinite;
    -o-animation-name:marquee;
    -o-animation-timing-function:linear;
    -o-animation-duration:10s;
    -o-animation-iteration-count:infinite;
    animation-name:marquee;
    animation-timing-function:linear;
    animation-duration:10s;
    animation-iteration-count:infinite;
  }
  @-webkit-keyframes marquee {
    from   { -webkit-transform: translate(0%);}
    99%,to { -webkit-transform: translate(-100%);}
  }
  @-moz-keyframes marquee {
    from   { -moz-transform: translate(0%);}
    99%,to { -moz-transform: translate(-100%);}
  }
  @-ms-keyframes marquee {
    from   { -ms-transform: translate(0%);}
    99%,to { -ms-transform: translate(-100%);}
  }
  @-o-keyframes marquee {
    from   { -o-transform: translate(0%);}
    99%,to { -o-transform: translate(-100%);}
  }
  @keyframes marquee {
    from   { transform: translate(0%);}
    99%,to { transform: translate(-100%);}
  }
  /deep/ p {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/atoms/MarqueeMessage.vue